export const lineIntersectsCircle = (
  line: [number, number][],
  circleCenter: { x: number; y: number },
  radius: number
): boolean => {
  for (let i = 0; i < line.length - 1; i++) {
    const p1 = { x: line[i][0], y: line[i][1] };
    const p2 = { x: line[i + 1][0], y: line[i + 1][1] };

    // Check if either endpoint is inside the circle
    const d1 = Math.hypot(p1.x - circleCenter.x, p1.y - circleCenter.y);
    const d2 = Math.hypot(p2.x - circleCenter.x, p2.y - circleCenter.y);
    if (d1 < radius || d2 < radius) return true;

    // Check if the segment intersects the circle
    // Vector from p1 to p2
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    const fx = p1.x - circleCenter.x;
    const fy = p1.y - circleCenter.y;

    const a = dx * dx + dy * dy;
    const b = 2 * (fx * dx + fy * dy);
    const c = fx * fx + fy * fy - radius * radius;

    const discriminant = b * b - 4 * a * c;
    if (discriminant >= 0) {
      // There is an intersection, check if it is within the segment
      const t1 = (-b - Math.sqrt(discriminant)) / (2 * a);
      const t2 = (-b + Math.sqrt(discriminant)) / (2 * a);
      if ((t1 >= 0 && t1 <= 1) || (t2 >= 0 && t2 <= 1)) {
        return true;
      }
    }
  }
  return false;
};
